import { render, staticRenderFns } from "./PlayNow.vue?vue&type=template&id=651aa4e3&"
import script from "./PlayNow.vue?vue&type=script&lang=js&"
export * from "./PlayNow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports